import { window } from "global";
import { ChampionDuosTable } from "./ChampionDuosTable";
import { TierListTablePlaceholder } from "@ugg/shared/components/TierList/common/TierListTablePlaceholder";
import { TierListTableError } from "@ugg/shared/components/TierList/common/TierListTableError";
import { getDuos } from "@ugg/shared/api/data-parser/champions/duos";
import { useChampionDuos } from "@ugg/shared/api/requests/champions/duos";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params//valid-params";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { normalizeRole } from "@ugg/shared/utils/role-helpers";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";

export function ChampionDuos() {
  const { championId, role } = useChampionProfileContext();

  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.DUOS, queryParams, true);
  const { data, loading, error } = useChampionDuos(championId, { params: validatedQueryParams, ssr: true });
  const championDuos = getDuos(data, { ...validatedQueryParams, role: normalizeRole(role || "") });
  let filteredChampionDuos = (championDuos && championDuos.duos) || [];

  if (validatedQueryParams.allChampions !== "true") {
    filteredChampionDuos = filteredChampionDuos.filter((champion) => champion.pick_rate >= 0.5);
  }

  if (!window || loading) {
    return <TierListTablePlaceholder />;
  } else if (error) {
    return <TierListTableError />;
  } else {
    return <ChampionDuosTable data={filteredChampionDuos} />;
  }
}
